import { appQueryClient } from 'libs/data-access/queries/src/lib/provider'

import { membershipNotificationsQueryKeys } from '../membership.notifications.cacheKeys'
import type { MembershipNotificationsSchema } from '../types/membership.notifications.schema'

export const updateNotificationsDataFromWS = (
  data: MembershipNotificationsSchema
) => {
  appQueryClient.setQueryData(
    membershipNotificationsQueryKeys.notifications(),
    data
  )
}
